<template>
    <!-- Content Wrapper. Contains page content -->
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0">{{ $route.params.id != 0 ? bonusName : 'Bonus Oluştur' }}</h1>
                    </div>

                    <!-- /.col -->
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <router-link tag="li" to="/" class="breadcrumb-item">
                                <a>Anasayfa</a>
                            </router-link>
                            <router-link tag="li" to="/bonus-list" class="breadcrumb-item">
                                <a>Bonus Listesi</a>
                            </router-link>
                            <li
                                class="breadcrumb-item active"
                            >Bonus {{ $route.params.id != 0 ? 'Düzenle' : 'Oluştur' }}</li>
                        </ol>
                    </div>
                    <!-- /.col -->
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->

        <!-- Main content -->
        <div class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="card card-primary card-tabs">
                            <div class="card-header p-0 pt-1 card-title">
                                <!-- Bonus Tabs -->
                                <ul class="nav nav-tabs">
                                    <li class="pt-2 px-3">
                                        <h3
                                            class="card-title"
                                        >Bonus {{ $route.params.id != 0 ? 'Düzenle' : 'Oluştur' }}</h3>
                                    </li>
                                    <li class="nav-item">
                                        <router-link
                                            tag="a"
                                            :to="'/bonus-list/settings/info/' + $route.params.id"
                                            class="nav-link"
                                            active-class="active"
                                            exact
                                            href="#"
                                        >Bonus Bilgiler</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link
                                            v-if="vipShow"
                                            tag="a"
                                            :to="'/bonus-list/settings/customer-connections/' + $route.params.id"
                                            class="nav-link"
                                            :class="$route.params.id == 0 ? 'disabled' : ''"
                                            active-class="active"
                                            exact
                                            href="#"
                                        >VIP Müşteri Bağlantıları</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link
                                            tag="a"
                                            :to="'/bonus-list/settings/bonus-odds/' + $route.params.id"
                                            class="nav-link"
                                            :class="$route.params.id == 0 ? 'disabled' : ''"
                                            active-class="active"
                                            exact
                                            href="#"
                                        >Bonus Oranları</router-link>
                                    </li>
                                    <!-- <button
                                        class="btn btn-sm btn-warning"
                                        style="position:absolute;right:5px;top:7px"
                                        @click="openUserGuideModal"
                                    >
                                        Bonus Kullanım Klavuzu
                                        <i class="fas fa-info-circle"></i>
                                    </button> -->
                                </ul>
                                <!-- /.bonus-tabs -->
                            </div>
                            <div class="card-body table-responsive">
                                <div class="tab-content" id="bonus-tabs">
                                    <router-view
                                        @bonus-name="bonusName = $event"
                                        @bonus-vip="vipShow = $event"
                                    ></router-view>
                                </div>
                            </div>
                            <div class="card-footer">
                                <div class="row"></div>
                            </div>
                        </div>

                        <!-- /.card -->
                    </div>
                    <div class="modal fade" id="modal-quide">
                        <div class="modal-dialog modal-xl">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h4 class="modal-title">Bonus Kullanım Klavuzu</h4>
                                    <button
                                        type="button"
                                        class="close"
                                        data-dismiss="modal"
                                        aria-label="Close"
                                    >
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <h4 class="ml-1">Bonus S.S.S <small>(Sıkça Sorulan Sorular)</small></h4>
                                        </div>
                                        <div class="col-md-12" id="accordion">
                                            <div class="card card-primary card-outline">
                                                <a
                                                    class="d-block w-100 collapsed"
                                                    data-toggle="collapse"
                                                    href="#s1"
                                                    aria-expanded="false"
                                                >
                                                    <div class="card-header">
                                                        <h4
                                                            class="card-title w-100"
                                                        >1. Lorem ipsum dolor sit amet</h4>
                                                    </div>
                                                </a>
                                                <div
                                                    id="s1"
                                                    class="collapse"
                                                    data-parent="#accordion"
                                                    style
                                                >
                                                    <div
                                                        class="card-body"
                                                    >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                                                </div>
                                            </div>
                                            <div class="card card-primary card-outline">
                                                <a
                                                    class="d-block w-100 collapsed"
                                                    data-toggle="collapse"
                                                    href="#s2"
                                                    aria-expanded="false"
                                                >
                                                    <div class="card-header">
                                                        <h4
                                                            class="card-title w-100"
                                                        >2. Lorem ipsum dolor sit amet</h4>
                                                    </div>
                                                </a>
                                                <div
                                                    id="s2"
                                                    class="collapse"
                                                    data-parent="#accordion"
                                                    style
                                                >
                                                    <div
                                                        class="card-body"
                                                    >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                                                </div>
                                            </div>
                                            <div class="card card-primary card-outline">
                                                <a
                                                    class="d-block w-100 collapsed"
                                                    data-toggle="collapse"
                                                    href="#s3"
                                                    aria-expanded="false"
                                                >
                                                    <div class="card-header">
                                                        <h4
                                                            class="card-title w-100"
                                                        >3. Lorem ipsum dolor sit amet</h4>
                                                    </div>
                                                </a>
                                                <div
                                                    id="s3"
                                                    class="collapse"
                                                    data-parent="#accordion"
                                                    style
                                                >
                                                    <div
                                                        class="card-body"
                                                    >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                                                </div>
                                            </div>
                                            <div class="card card-primary card-outline">
                                                <a
                                                    class="d-block w-100 collapsed"
                                                    data-toggle="collapse"
                                                    href="#s4"
                                                    aria-expanded="false"
                                                >
                                                    <div class="card-header">
                                                        <h4
                                                            class="card-title w-100"
                                                        >4. Lorem ipsum dolor sit amet</h4>
                                                    </div>
                                                </a>
                                                <div
                                                    id="s4"
                                                    class="collapse"
                                                    data-parent="#accordion"
                                                    style
                                                >
                                                    <div
                                                        class="card-body"
                                                    >Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor.</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="modal-footer justify-content-between">
                                    <button
                                        type="button"
                                        class="btn btn-default"
                                        data-dismiss="modal"
                                    >Kapat</button>
                                </div>
                            </div>
                            <!-- /.modal-content -->
                        </div>
                        <!-- /.modal-dialog -->
                    </div>
                </div>
                <!-- /.row -->
            </div>
            <!-- /.container-fluid -->
        </div>
        <!-- /.content -->
    </div>
    <!-- /.content-wrapper -->
</template>

<script>

export default {
    data() {
        return {

            bonusName: "",
            vipShow: true
        };
    },
    methods: {
        openUserGuideModal() {
            $('#modal-quide').modal();
        }
    }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/BonusList/BonusSettings.vue